/**
 * externalLink — helpers for outbound links to sister-site pages.
 *
 * 1. withLang(url, lang) — when the viewer is on `/ja/...` pages, mirror
 *    the path on the destination site with a `/ja` prefix so they land
 *    on the Japanese version. English stays as-is (the default route on
 *    every sister site).
 *
 * 2. The component layer is responsible for resolving any service-level
 *    URL overrides (e.g. JapanETCcard currently points feature/plan
 *    URLs to the DEV host `japancardetc.com`; the LIVE host
 *    `japanetccard.com` stays the brand label).
 */

export function withLang(url, lang) {
  if (!url || lang !== "ja") return url;
  try {
    const u = new URL(url);
    // Don't double-prefix if /ja is already in the path.
    if (u.pathname === "/ja" || u.pathname.startsWith("/ja/")) return url;
    u.pathname = u.pathname === "/" ? "/ja" : `/ja${u.pathname}`;
    return u.toString();
  } catch {
    return url;
  }
}
